import { render, staticRenderFns } from "./SelectCategoryGroup.vue?vue&type=template&id=1b79e524"
import script from "./SelectCategoryGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectCategoryGroup.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b79e524')) {
      api.createRecord('1b79e524', component.options)
    } else {
      api.reload('1b79e524', component.options)
    }
    module.hot.accept("./SelectCategoryGroup.vue?vue&type=template&id=1b79e524", function () {
      api.rerender('1b79e524', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/group/category/components/SelectCategoryGroup.vue"
export default component.exports